module.exports = __webpack_public_path__ + "static/media/heart.dc25d501.png";